export interface ApiError {
  response: {
    errors: {
      message: string
      extensions?: {
        code: string
        response: {
          statusCode: number
          message: string[]
          error: string
        }
        originalError: {
          statusCode: number
          message: string[]
          error: string
        }
      }
    }[]
  }
}

export const getErrorsMessagesFromResponse = (errorResponse: any) => {
  const errors = errorResponse?.response?.errors
  if (errors) {
    return errors.map((error: any) => error.extensions.originalError.error)
  }
  return []
}

export const getErrorsFromResponse = (errorResponse: any) => {
  const errors = errorResponse?.response?.errors
  if (errors) {
    return errors.map((error: any) => error.message)
  }
  return []
}

export const getErrorsFromApiError = (apiError: ApiError) => {
  const errors = apiError?.response?.errors
  if (errors) {
    return errors[0].extensions?.response
      ? errors[0].extensions.response.message
      : errors.map((error) => error.message)
  }
  return []
}

export const getErrorStatusCode = (apiError: ApiError) => {
  const errors = apiError?.response?.errors
  if (errors) {
    return (
      errors[0]?.extensions?.originalError?.statusCode ??
      errors[0]?.extensions?.response?.statusCode ??
      null
    )
  }
  return null
}
